import {
  InMemoryHeader,
  InMemoryString,
  InMemoryBoolean,
  InMemoryDate,
  InMemoryDecimal,
} from "pbas-vue-components";

import { translate } from "../trans";
import store from "@/store";
function formatDate(dateString) {
  if (dateString === undefined || dateString === null) {
    return "";
  }
  const [date, time] = dateString.split("T");
  const [year, month, day] = date.split("-");
  return `${year}-${month}-${day}`;
}
const PensionInMemoryBeneficiariesHeaders = [
  new InMemoryHeader({
    title: "Id",
    type: new InMemoryString("Id"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title: "IdentityId",
    type: new InMemoryString("IdentityId"),
    sortable: true,
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title: "views.beneficiaries.declaration_date",
    type: new InMemoryDate("DeclarationDate"),
    sortable: true,
    visible: false,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "views.beneficiaries.pension_beneficiary_id",
    type: new InMemoryString("PensionBeneficiaryId"),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "globals.type",
    type: new InMemoryString("BeneficiaryType/Name"),
    sortable: true,
    visible: false,
    searchable: true,
    allowVisibilityChange: false,
    version: 1,
  }),
  new InMemoryHeader({
    type: new InMemoryString("BeneficiaryType/Translations[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new InMemoryHeader({
    title: "globals.type",
    type: new InMemoryString("BeneficiaryType/Translations[]/DisplayValue", {
      getString: (item) => {
        if (!item) return "";
        const lang = store.getters["common/language"];
        return translate(item.BeneficiaryType, lang.language);
      },
    }),
    visible: true,
    searchable: true,
    sortable: true,
    orderByKey: "BeneficiaryType/Name",
    version: 1,
  }),
  new InMemoryHeader({
    title: "Beneficiary Type Id",
    type: new InMemoryString("BeneficiaryType/Id"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new InMemoryHeader({
    title: "BeneficiaryTypeId",
    type: new InMemoryString("BeneficiaryTypeId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new InMemoryHeader({
    title: "components.inmemorydependants.relationship",
    type: new InMemoryString("BeneficiaryRelationship/Name"),
    sortable: true,
    visible: false,
    searchable: true,
    allowVisibilityChange: false,
    version: 1,
  }),
  new InMemoryHeader({
    type: new InMemoryString(
      "BeneficiaryRelationship/Translations[]/LanguageCode"
    ),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new InMemoryHeader({
    title: "components.inmemorydependants.relationship",
    type: new InMemoryString(
      "BeneficiaryRelationship/Translations[]/DisplayValue",
      {
        getString: (item) => {
          if (!item) return "";
          const lang = store.getters["common/language"];
          return translate(item.BeneficiaryRelationship, lang.language);
        },
      }
    ),
    visible: true,
    searchable: true,
    sortable: true,
    orderByKey: "BeneficiaryRelationship/Name",
    version: 1,
  }),
  new InMemoryHeader({
    title: "Beneficiary Relationship Id",
    type: new InMemoryString("BeneficiaryRelationship/Id"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new InMemoryHeader({
    title: "BeneficiaryRelationshipId",
    type: new InMemoryString("BeneficiaryRelationshipId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new InMemoryHeader({
    title: "headers.members_management.SIN",
    type: new InMemoryString("SIN"),
    sortable: true,
  }),
  new InMemoryHeader({
    title: "headers.members_management.Title",
    type: new InMemoryString("Title", {
      getString: item => {
        if (!item || !item.BeneficiaryRelationship) return "";
        const lang = store.getters['common/language']
        if (
          
          item.BeneficiaryRelationship.IsSpouse ||
          item.BeneficiaryRelationship.IsChild
        ) {
          if (item.DependantIdentity) {
            return item.DependantIdentity.Current
              ? translate(item.DependantIdentity.Current.Title, lang.language)
              : translate(item.DependantIdentity.Title, lang.language);
          }
        }
        return translate(item.Title, lang.language);
      }
    }),
    sortable: true,
  }),
  new InMemoryHeader({
    title: "globals.firstname",
    type: new InMemoryString("FirstName", {
      getString: (item) => {
        console.log(item);
        if (!item) return "";
        if (!item.BeneficiaryRelationship) return item.FirstName;
        if (
          item.BeneficiaryRelationship.IsSpouse ||
          item.BeneficiaryRelationship.IsChild
        ) {
          if (item.DependantIdentity) {
            return item.DependantIdentity.Current
              ? item.DependantIdentity.Current.FirstName
              : item.DependantIdentity.FirstName;
          }
        }
        return item.FirstName;
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "globals.middlename",
    type: new InMemoryString("MiddleName", {
      getString: (item) => {
        if (!item || !item.BeneficiaryRelationship) return "";
        if (
          item.BeneficiaryRelationship.IsSpouse ||
          item.BeneficiaryRelationship.IsChild
        ) {
          if (item.DependantIdentity) {
            return item.DependantIdentity.Current
              ? item.DependantIdentity.Current.MiddleName
              : item.DependantIdentity.MiddleName;
          }
        }
        return item.MiddleName;
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "globals.lastname",
    type: new InMemoryString("LastName", {
      getString: (item) => {
        if (!item || !item.BeneficiaryRelationship) return "";
        if (
          item.BeneficiaryRelationship.IsSpouse ||
          item.BeneficiaryRelationship.IsChild
        ) {
          if (item.DependantIdentity) {
            return item.DependantIdentity.Current
              ? item.DependantIdentity.Current.LastName
              : item.DependantIdentity.LastName;
          }
        }
        return item.LastName;
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.members_management.Suffix",
    type: new InMemoryString("Suffix", {
      getString: item => {
        if (!item || !item.BeneficiaryRelationship) return "";
        const lang = store.getters['common/language']
        if (
          item.BeneficiaryRelationship.IsSpouse ||
          item.BeneficiaryRelationship.IsChild
        ) {
          if (item.DependantIdentity) {
            return item.DependantIdentity.Current
              ? translate(item.DependantIdentity.Current.Suffix, lang.language)
              : translate(item.DependantIdentity.Suffix, lang.language);
          }
        }
        return translate(item.Suffix, lang.language);
      }
    }),
    sortable: true,
  }),
  new InMemoryHeader({
    title: "globals.gender",
    type: new InMemoryString("Gender/Name"),
    sortable: true,
    visible: false,
    searchable: true,
    allowVisibilityChange: false,
    version: 1,
  }),
  new InMemoryHeader({
    type: new InMemoryString("Gender/Translations[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new InMemoryHeader({
    title: "globals.gender",
    type: new InMemoryString("Gender/Translations[]/DisplayValue", {
      getString: (item) => {
        if (!item || !item.BeneficiaryRelationship) return "";
        const lang = store.getters["common/language"];
        if (
          item.BeneficiaryRelationship.IsSpouse ||
          item.BeneficiaryRelationship.IsChild
        ) {
          if (item.DependantIdentity) {
            return item.DependantIdentity.Current
              ? translate(item.DependantIdentity.Current.Gender, lang.language)
              : translate(item.DependantIdentity.Gender, lang.language);
          }
        }
        return translate(item.Gender, lang.language);
      },
    }),
    visible: true,
    searchable: true,
    sortable: true,
    orderByKey: "Gender/Name",
    version: 1,
  }),
  new InMemoryHeader({
    title: "Gender Id",
    type: new InMemoryString("Gender/Id"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new InMemoryHeader({
    title: "GenderId",
    type: new InMemoryString("GenderId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new InMemoryHeader({
    title: "globals.dob",
    type: new InMemoryDate("DateOfBirth", {
      getString: (item) => {
        if (!item || !item.BeneficiaryRelationship) return "";
        if (
          item.BeneficiaryRelationship.IsSpouse ||
          item.BeneficiaryRelationship.IsChild
        ) {
          console.log(item);
          if (item.DependantIdentity) {
            return item.DependantIdentity.Current
              ? formatDate(item.DependantIdentity.Current.DateOfBirth)
              : formatDate(item.DependantIdentity.DateOfBirth);
          }
          return formatDate(item.DateOfBirth);
        }
        return item.DateOfBirth;
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "components.inmemorydependants.dod",
    type: new InMemoryDate("DateOfDeath", {
      getString: (item) => {
        if (!item || !item.BeneficiaryRelationship) return "";
        if (
          item.BeneficiaryRelationship.IsSpouse ||
          item.BeneficiaryRelationship.IsChild
        ) {
          // console.log(item);
          if (item.DependantIdentity) {
            return item.DependantIdentity.Current
              ? formatDate(item.DependantIdentity.Current.DateOfDeath)
              : formatDate(item.DependantIdentity.DateOfDeath);
          }
          return formatDate(item.DateOfDeath);
        }
        return item.DateOfDeath;
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "components.plancreationwizard.primary",
    type: new InMemoryBoolean("IsPrimary"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "views.beneficiaries.revocable",
    type: new InMemoryBoolean("IsRevocable"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "views.beneficiaries.add_trustee",
    type: new InMemoryBoolean("AddTrustee"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "views.beneficiaries.percentage",
    type: new InMemoryDecimal("Percentage", {
      getString: (item, type) => {
        const value = item.Percentage;
        if (value === null || value === undefined) {
          return "";
        }
        const parsed = parseFloat(item.Percentage);
        if (isNaN(parsed)) {
          return "";
        }
        return parsed.toFixed(2) + "%";
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
];
const HwInMemoryBeneficiariesHeaders = [
  new InMemoryHeader({
    title: "Id",
    type: new InMemoryString("Id"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title: "IdentityId",
    type: new InMemoryString("IdentityId"),
    sortable: true,
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title: "views.beneficiaries.declaration_date",
    type: new InMemoryDate("DeclarationDate"),
    sortable: true,
    visible: false,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "globals.type",
    type: new InMemoryString("BeneficiaryType/Name"),
    sortable: true,
    visible: false,
    searchable: true,
    allowVisibilityChange: false,
    version: 1,
  }),
  new InMemoryHeader({
    type: new InMemoryString("BeneficiaryType/Translations[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new InMemoryHeader({
    title: "globals.type",
    type: new InMemoryString("BeneficiaryType/Translations[]/DisplayValue", {
      getString: (item) => {
        if (!item) return "";
        const lang = store.getters["common/language"];
        return translate(item.BeneficiaryType, lang.language);
      },
    }),
    visible: true,
    searchable: true,
    sortable: true,
    orderByKey: "BeneficiaryType/Name",
    version: 1,
  }),
  new InMemoryHeader({
    title: "Beneficiary Type Id",
    type: new InMemoryString("BeneficiaryType/Id"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new InMemoryHeader({
    title: "BeneficiaryTypeId",
    type: new InMemoryString("BeneficiaryTypeId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new InMemoryHeader({
    title: "components.inmemorydependants.relationship",
    type: new InMemoryString("BeneficiaryRelationship/Name"),
    sortable: true,
    visible: false,
    searchable: true,
    allowVisibilityChange: false,
    version: 1,
  }),
  new InMemoryHeader({
    type: new InMemoryString(
      "BeneficiaryRelationship/Translations[]/LanguageCode"
    ),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new InMemoryHeader({
    title: "components.inmemorydependants.relationship",
    type: new InMemoryString(
      "BeneficiaryRelationship/Translations[]/DisplayValue",
      {
        getString: (item) => {
          if (!item) return "";
          const lang = store.getters["common/language"];
          return translate(item.BeneficiaryRelationship, lang.language);
        },
      }
    ),
    visible: true,
    searchable: true,
    sortable: true,
    orderByKey: "BeneficiaryRelationship/Name",
    version: 1,
  }),
  new InMemoryHeader({
    title: "Beneficiary Relationship Id",
    type: new InMemoryString("BeneficiaryRelationship/Id"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new InMemoryHeader({
    title: "BeneficiaryRelationshipId",
    type: new InMemoryString("BeneficiaryRelationshipId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new InMemoryHeader({
    title: "headers.members_management.SIN",
    type: new InMemoryString("SIN"),
    sortable: true,
  }),
  new InMemoryHeader({
    title: "headers.members_management.Title",
    type: new InMemoryString("Title", {
      getString: item => {
        if (!item || !item.BeneficiaryRelationship) return "";
        const lang = store.getters['common/language']
        if (
          
          item.BeneficiaryRelationship.IsSpouse ||
          item.BeneficiaryRelationship.IsChild
        ) {
          if (item.DependantIdentity) {
            return item.DependantIdentity.Current
              ? translate(item.DependantIdentity.Current.Title, lang.language)
              : translate(item.DependantIdentity.Title, lang.language);
          }
        }
        return translate(item.Title, lang.language);
      }
    }),
    sortable: true,
  }),
  new InMemoryHeader({
    title: "globals.firstname",
    type: new InMemoryString("FirstName", {
      getString: (item) => {
        console.log(item);
        if (!item) return "";
        if (!item.BeneficiaryRelationship) return item.FirstName;
        if (
          item.BeneficiaryRelationship.IsSpouse ||
          item.BeneficiaryRelationship.IsChild
        ) {
          if (item.DependantIdentity) {
            return item.DependantIdentity.Current
              ? item.DependantIdentity.Current.FirstName
              : item.DependantIdentity.FirstName;
          }
        }
        return item.FirstName;
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "globals.middlename",
    type: new InMemoryString("MiddleName", {
      getString: (item) => {
        if (!item || !item.BeneficiaryRelationship) return "";
        if (
          item.BeneficiaryRelationship.IsSpouse ||
          item.BeneficiaryRelationship.IsChild
        ) {
          if (item.DependantIdentity) {
            return item.DependantIdentity.Current
              ? item.DependantIdentity.Current.MiddleName
              : item.DependantIdentity.MiddleName;
          }
        }
        return item.MiddleName;
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "globals.lastname",
    type: new InMemoryString("LastName", {
      getString: (item) => {
        if (!item || !item.BeneficiaryRelationship) return "";
        if (
          item.BeneficiaryRelationship.IsSpouse ||
          item.BeneficiaryRelationship.IsChild
        ) {
          if (item.DependantIdentity) {
            return item.DependantIdentity.Current
              ? item.DependantIdentity.Current.LastName
              : item.DependantIdentity.LastName;
          }
        }
        return item.LastName;
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.members_management.Suffix",
    type: new InMemoryString("Suffix", {
      getString: item => {
        if (!item || !item.BeneficiaryRelationship) return "";
        const lang = store.getters['common/language']
        if (
          item.BeneficiaryRelationship.IsSpouse ||
          item.BeneficiaryRelationship.IsChild
        ) {
          if (item.DependantIdentity) {
            return item.DependantIdentity.Current
              ? translate(item.DependantIdentity.Current.Suffix, lang.language)
              : translate(item.DependantIdentity.Suffix, lang.language);
          }
        }
        return translate(item.Suffix, lang.language);
      }
    }),
    sortable: true,
  }),
  new InMemoryHeader({
    title: "globals.gender",
    type: new InMemoryString("Gender/Name"),
    sortable: true,
    visible: false,
    searchable: true,
    allowVisibilityChange: false,
    version: 1,
  }),
  new InMemoryHeader({
    type: new InMemoryString("Gender/Translations[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new InMemoryHeader({
    title: "globals.gender",
    type: new InMemoryString("Gender/Translations[]/DisplayValue", {
      getString: (item) => {
        if (!item || !item.BeneficiaryRelationship) return "";
        const lang = store.getters["common/language"];
        if (
          item.BeneficiaryRelationship.IsSpouse ||
          item.BeneficiaryRelationship.IsChild
        ) {
          if (item.DependantIdentity) {
            return item.DependantIdentity.Current
              ? translate(item.DependantIdentity.Current.Gender, lang.language)
              : translate(item.DependantIdentity.Gender, lang.language);
          }
        }
        return translate(item.Gender, lang.language);
      },
    }),
    visible: true,
    searchable: true,
    sortable: true,
    orderByKey: "Gender/Name",
    version: 1,
  }),
  new InMemoryHeader({
    title: "Gender Id",
    type: new InMemoryString("Gender/Id"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new InMemoryHeader({
    title: "GenderId",
    type: new InMemoryString("GenderId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new InMemoryHeader({
    title: "globals.dob",
    type: new InMemoryDate("DateOfBirth", {
      getString: (item) => {
        if (!item || !item.BeneficiaryRelationship) return "";
        if (
          item.BeneficiaryRelationship.IsSpouse ||
          item.BeneficiaryRelationship.IsChild
        ) {
          console.log(item);
          if (item.DependantIdentity) {
            return item.DependantIdentity.Current
              ? formatDate(item.DependantIdentity.Current.DateOfBirth)
              : formatDate(item.DependantIdentity.DateOfBirth);
          }
          return formatDate(item.DateOfBirth);
        }
        return item.DateOfBirth;
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "components.inmemorydependants.dod",
    type: new InMemoryDate("DateOfDeath", {
      getString: (item) => {
        if (!item || !item.BeneficiaryRelationship) return "";
        if (
          item.BeneficiaryRelationship.IsSpouse ||
          item.BeneficiaryRelationship.IsChild
        ) {
          // console.log(item);
          if (item.DependantIdentity) {
            return item.DependantIdentity.Current
              ? formatDate(item.DependantIdentity.Current.DateOfDeath)
              : formatDate(item.DependantIdentity.DateOfDeath);
          }
          return formatDate(item.DateOfDeath);
        }
        return item.DateOfDeath;
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "components.plancreationwizard.primary",
    type: new InMemoryBoolean("IsPrimary"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "views.beneficiaries.revocable",
    type: new InMemoryBoolean("IsRevocable"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "views.beneficiaries.add_trustee",
    type: new InMemoryBoolean("AddTrustee"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "views.beneficiaries.percentage",
    type: new InMemoryDecimal("Percentage", {
      getString: (item, type) => {
        const value = item.Percentage;
        if (value === null || value === undefined) {
          return "";
        }
        const parsed = parseFloat(item.Percentage);
        if (isNaN(parsed)) {
          return "";
        }
        return parsed.toFixed(2) + "%";
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
];
function getInMemoryBeneficiariesHeaders(planType) {
  if (planType === "Pension") {
    return PensionInMemoryBeneficiariesHeaders;
  }
  return HwInMemoryBeneficiariesHeaders;
}
export default getInMemoryBeneficiariesHeaders;
